import Breakpoints from 'utils/breakpoints.module.scss'

const phoneMaxWidth = parseInt(Breakpoints.phoneMaxWidth)
export function isMobile() {
  return window.innerWidth < phoneMaxWidth
}
